module.exports = __webpack_public_path__ + "img/flood.dbd96c68.png";